import { render } from "./LivingProgram.vue?vue&type=template&id=42aa1416&scoped=true"
import script from "./LivingProgram.vue?vue&type=script&lang=js"
export * from "./LivingProgram.vue?vue&type=script&lang=js"

import "./LivingProgram.vue?vue&type=style&index=0&id=42aa1416&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-42aa1416"

export default script